/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskPriorityEnum } from './taskPriorityEnum';
import { TaskReferenceRequirementEnum } from './taskReferenceRequirementEnum';
import { TaskTeam } from './taskTeam';


import {ValidatorFn, Validators} from "@angular/forms";

export interface TaskSubject { 
    readonly id: number;
    name: string;
    readonly patientReference: TaskReferenceRequirementEnum;
    readonly appointmentReference: TaskReferenceRequirementEnum;
    /**
     * Therapeut:innen können Aufgaben mit diesem Betreff erstellen.
     */
    isTherapistCreatable?: boolean;
    /**
     * Aufgaben mit diesem Betreff werden von Therapeut:innen statt von einem Patient Ops Team bearbeitet.
     */
    isExecutedByTherapist?: boolean;
    /**
     * A recurring job creates and closes these tasks from a live condition; users can never close, edit or delete them. Unlike \'System created\', where a human still closes it.
     */
    isSystemManaged?: boolean;
    readonly isRecheckable: boolean;
    /**
     * Due date = reference date + N business days (Mon-Fri). Can only be combined with due-before-appointment when the appointment reference is optional; it is then the fallback for tasks without an appointment.
     */
    dueInBusinessDays?: number | null;
    /**
     * Due date = appointment date minus N business days (positive = before). Not allowed when the appointment reference is hidden. Can only be combined with due-in-business-days when the appointment reference is optional.
     */
    dueBeforeAppointmentBusinessDays?: number | null;
    /**
     * Stunden vor dem Fälligkeitsdatum, ab denen Aufgaben als bald fällig hervorgehoben werden.
     */
    dueDateWarningHours?: number | null;
    /**
     * Standardbeschreibung, die beim Erstellen von Aufgaben mit diesem Betreff vorausgefüllt wird.
     */
    defaultDescription?: string;
    readonly defaultPriority: TaskPriorityEnum;
    readonly teams: Array<TaskTeam>;
    readonly defaultAssignedTeam: TaskTeam;
}
export namespace TaskSubject {
}

export const TaskSubject_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskSubject_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const TaskSubject_patientReference_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskSubject_appointmentReference_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskSubject_isTherapistCreatable_Validators: ValidatorFn[] =
    [ ];

export const TaskSubject_isExecutedByTherapist_Validators: ValidatorFn[] =
    [ ];

export const TaskSubject_isSystemManaged_Validators: ValidatorFn[] =
    [ ];

export const TaskSubject_isRecheckable_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskSubject_dueInBusinessDays_Validators: ValidatorFn[] =
    [  Validators.min(0), Validators.max(2147483647),];

export const TaskSubject_dueBeforeAppointmentBusinessDays_Validators: ValidatorFn[] =
    [  Validators.min(-2147483648), Validators.max(2147483647),];

export const TaskSubject_dueDateWarningHours_Validators: ValidatorFn[] =
    [  Validators.min(0), Validators.max(2147483647),];

export const TaskSubject_defaultDescription_Validators: ValidatorFn[] =
    [ ];

export const TaskSubject_defaultPriority_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskSubject_teams_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskSubject_defaultAssignedTeam_Validators: ValidatorFn[] =
    [  Validators.required, ];


